// styles
import { NotificationStyles } from "./notification.styles";

const BellIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2a6 6 0 0 0-6 6v3.586l-1.707 1.707A1 1 0 0 0 5 15h14a1 1 0 0 0 .707-1.707L18 11.586V8a6 6 0 0 0-6-6zm0 20a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22z" />
  </svg>
);

const Notification = ({ text, time }) => {
  return (
    <NotificationStyles>
      <span className="bellCircle" aria-hidden>
        <BellIcon />
      </span>
      <span className="body">{text}</span>
      {time && <span className="time">{time}</span>}
    </NotificationStyles>
  );
};

export default Notification;
